export const TERMS_OF_SERVICE = `1. Terms of Service (Hosted SaaS)

Terms of Service
Last updated: February 2026

These Terms of Service ("Terms") govern access to and use of the SimplyInventory service ("Service"), operated by Meyer Software Services.
By accessing or using the Service, you agree to be bound by these Terms.

________________________________________

1. The Service
SimplyInventory is a hosted, cloud-based software service provided over the internet.
Customers access the Service via a web interface and/or API.
No software is sold, licensed, or delivered to the customer.

________________________________________

2. Access & Use
• You are granted a non-exclusive, non-transferable right to access the Service during your subscription term.
• You may use the Service only for lawful business purposes.
• You may not attempt to reverse engineer, copy, or resell the Service.

________________________________________

3. Customer Data
• You retain ownership of all data you submit to the Service.
• We process data solely to provide and maintain the Service.
• We implement reasonable security measures to protect customer data.

________________________________________

4. Availability
• We aim to provide high availability but do not guarantee uninterrupted access.
• Maintenance, updates, or outages may occur.

________________________________________

5. Fees & Payment
• Fees are agreed separately in a commercial agreement or invoice.
• Failure to pay may result in suspension or termination of access.

________________________________________

6. Intellectual Property
• All rights, title, and interest in the Service remain with Meyer Software Services.
• These Terms do not grant ownership or licensing rights to the underlying software.

________________________________________

7. Termination
We may suspend or terminate access if these Terms are violated or if required by law.

________________________________________

8. Limitation of Liability
To the maximum extent permitted by law, we are not liable for indirect, incidental, or consequential damages.

________________________________________

9. Governing Law
These Terms are governed by the laws of England and Wales.

________________________________________

10. Contact
For questions about these Terms, contact: izak.meyer@simplyinventory.co.uk

________________________________________

Hosted Service Only
The Service is provided exclusively as a hosted, cloud-based solution.
No executable software, source code, or binaries are delivered, licensed, or transferred to the customer under these Terms.`;

export const LICENSES = `Open-Source Acknowledgements

This service makes use of open-source software.
We gratefully acknowledge the developers and contributors of the following projects.

The Service is operated as a hosted platform. No third-party open-source software is distributed to customers.

________________________________________

MIT License

• Express — MIT License
• Helmet — MIT License
• jsonwebtoken — MIT License
• uuid — MIT License
• bcryptjs — MIT License
• archiver — MIT License
• multer — MIT License
• cors — MIT License

________________________________________

MIT-0 License

• nodemailer — MIT-0 License

________________________________________

Apache License 2.0

• xlsx — Apache License 2.0
• RxJS — Apache License 2.0

________________________________________

BSD Licenses

BSD-2-Clause

• dotenv — BSD-2-Clause License

BSD-3-Clause

• qs — BSD-3-Clause License

________________________________________

ISC License

• glob — ISC License
• rimraf — ISC License
• semver — ISC License

________________________________________

Other Permissive Licenses

• tslib — 0BSD License
• jackspeak — BlueOak-1.0.0 License
• package-json-from-dist — BlueOak-1.0.0 License
• path-scurry — BlueOak-1.0.0 License

________________________________________

Creative Commons

• caniuse-lite — CC-BY-4.0 License

________________________________________

Full license texts are available from their respective project repositories.`;
